import React from "react";
import { withFormsy } from "formsy-react";
import Radium from "radium";
import FileInput from "../UIKit/FileInput";

class JumperFormsyFileInput extends React.Component {
  constructor() {
    super();
    this.onDrop = this.onDrop.bind(this);
  }

  showRequired() {
    // empty method to silence console warning
  }

  onDrop(acceptedFiles, rejectedFiles) {
    acceptedFiles.forEach(file => {
      const reader = new FileReader();
      reader.onload = () => {
        // const fileAsDataUrl = reader.result;
        // do whatever you want with the file content
      };
      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");

      reader.readAsDataURL(file);
    });

    this.props.setValue({
      accepted: acceptedFiles,
      rejected: rejectedFiles
    });
  }

  showError() {
    if (this.props.isPristine()) {
      return false;
    }

    return !this.props.isValid();
  }

  getPropsForState() {
    return Object.assign(
      {},
      this.showError() ? { error: true } : {},
      this.props.showRequired() ? { showRequired: true } : {}
    );
  }

  extractInputProps() {
    const {
      setValidations,
      setValue,
      resetValue,
      getValue,
      hasValue,
      getErrorMessage,
      getErrorMessages,
      isFormDisabled,
      isValid,
      isPristine,
      isFormSubmitted,
      isRequired,
      showRequired,
      showError,
      isValidValue,
      validationError,
      validationErrors,
      value,
      ...inputProps
    } = this.props;

    return inputProps;
  }

  render() {
    const inputProps = this.extractInputProps();
    const validationProps = this.getPropsForState();
    return (
      <FileInput
        value={this.props.getValue()}
        onChange={value => this.props.setValue(value)}
        {...inputProps}
        {...validationProps}
      />
    );
  }
}
export default withFormsy(Radium(JumperFormsyFileInput));



// WEBPACK FOOTER //
// ./src/components/Formsy/FileInput.js